import React, { useState } from 'react';
import {
  Box,
  Button,
  Drawer,
  Typography,
  IconButton,
  Badge,
  Divider,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { FilterList as FilterListIcon, Close as CloseIcon } from '@mui/icons-material';

// Collapses an arbitrary filter row (Selects, TextFields, date pickers — passed
// as children) behind a "Filters" trigger on mobile, opening a bottom Drawer.
// At sm+, renders children exactly as authored — desktop's inline filter row
// is completely unaffected.
export default function MobileFilterSheet({ children, activeCount = 0, label = 'Filters', onReset }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(false);

  if (!isMobile) return <>{children}</>;

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={
          <Badge badgeContent={activeCount} color="primary" invisible={!activeCount}>
            <FilterListIcon fontSize="small" />
          </Badge>
        }
        onClick={() => setOpen(true)}
        sx={{ mb: 1.5 }}
      >
        {label}
      </Button>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{ sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16, maxHeight: '80vh' } }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5 }}>
          <Typography variant="subtitle1" fontWeight="bold">{label}</Typography>
          <IconButton size="small" onClick={() => setOpen(false)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Divider />
        <Box sx={{ p: 2, overflowY: 'auto' }}>
          {children}
        </Box>
        <Divider />
        <Box sx={{ display: 'flex', gap: 1, p: 2, pb: 'calc(16px + env(safe-area-inset-bottom))' }}>
          {onReset && (
            <Button fullWidth variant="outlined" onClick={() => { onReset(); }}>
              Reset
            </Button>
          )}
          <Button fullWidth variant="contained" onClick={() => setOpen(false)}>
            Apply
          </Button>
        </Box>
      </Drawer>
    </>
  );
}
